
import {defineComponent, computed, ref, PropType} from 'vue';
import {FilterMatchMode} from 'primevue/api';

export default defineComponent({
  props: {
    modelValue: {type: Array as PropType<number[]>, required: true},
    options: {type: Array as PropType<any[]>, required: true},
    labelField: {type: String, required: true},
    valueField: {type: String, required: true},
    danhTu: {type: String, default: 'dịch vụ'},
    disabled: {type: Boolean, default: false}
  },
  emits: ['update:modelValue'],
  setup(props, {emit}) {
    const filters = ref({global: {value: null, matchMode: FilterMatchMode.CONTAINS}});
    const moChiTiet = ref(false);
    const daChon = computed(() => new Set(props.modelValue));
    const tatCa = computed(() => props.options.length > 0 && props.options.every(x => daChon.value.has(x[props.valueField])));
    const capNhat = (ids: number[]) => { moChiTiet.value = false; emit('update:modelValue', ids); };
    const chonTatCa = (value: boolean) => capNhat(value ? props.options.map(x => x[props.valueField]) : []);
    const chonDong = (id: number, value: boolean) => {
      const ids = new Set(props.modelValue);
      if (value) ids.add(id); else ids.delete(id);
      emit('update:modelValue', [...ids]);
    };
    return {filters, moChiTiet, daChon, tatCa, capNhat, chonTatCa, chonDong};
  }
});
